export const getSharedPostData = (message) => {
  if (String(message?.type || "").toUpperCase() !== "SHARED_POST") return null;
  let content = {};
  try {
    const value = message.content || message.text || "{}";
    content = typeof value === "string" ? JSON.parse(value) : value;
  } catch {
    // A deleted or malformed post still renders an unavailable-post placeholder.
  }
  const id = Number(message.post_id ?? content?.post_id);
  return {
    postId: Number.isSafeInteger(id) && id > 0 ? id : null,
    optionalMessage:
      typeof message.optional_message === "string"
        ? message.optional_message
        : typeof content?.optional_message === "string"
          ? content.optional_message
          : "",
    post: message.shared_post || null,
  };
};
